/**
 * @generated SignedSource<<c7cb3cc83a727c607984c2dec744f368>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespBrowseHeader_itemSearch$data = {
  readonly pageType: string | null;
  readonly meta: {
    readonly header: string | null;
  } | null;
  readonly " $fragmentType": "SbRespBrowseHeader_itemSearch";
};
export type SbRespBrowseHeader_itemSearch$key = {
  readonly " $data"?: SbRespBrowseHeader_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespBrowseHeader_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespBrowseHeader_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "df9a6382a85f3b62d385a5c88149c62b";

export default node;
